import React, { ReactElement } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Outlet, useLocation } from 'react-router-dom';
import { zodResolver } from '@hookform/resolvers/zod';
import { EAppRoutes } from '@common/enums';
import { bulkEditSchema } from '@features/bulk-edit/contexts/schemas';
import { BulkStrategiesEditForm } from '@features/bulk-edit/interfaces';
import { TargetingContextProvider } from '@features/targeting/hooks/useTargetingContextProvider';

export const BulkTargetingRouteWithContext = (): ReactElement => {
  const location = useLocation();

  const formMethods = useForm<BulkStrategiesEditForm>({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: zodResolver(bulkEditSchema),
    defaultValues: {
      removeAllOptimization: false,
      strategies: {},
      optimization: {
        audiences: {},
        creatives: {},
        locations: { items: [] },
        targeting: {
          geographical: {},
          pointOfInterest: [],
          dayPartingPanel: [],
          videoPlacement: {},
          bannerPlacement: {},
          verifiedSource: {},
          supplySource: {},
          deviceType: {},
          browser: {},
          operatingSystem: {},
          carrier: {},
          frequency: {},
          appSiteList: {},
          deals: {},
        },
      },
    },
  });

  const clearLastUpdatedCategory = location.pathname === EAppRoutes.BulkEditStrategy;

  return (
    <FormProvider {...formMethods}>
      <TargetingContextProvider clearLastUpdatedCategory={clearLastUpdatedCategory}>
        <Outlet />
      </TargetingContextProvider>
    </FormProvider>
  );
};
